// extracted by mini-css-extract-plugin
export default {"icon":"ShareIcon_icon__MBIuK"};